// extracted by mini-css-extract-plugin
module.exports = {"container":"card_container__3c2on","isDeposit":"card_isDeposit__3sGDM","depositContainer":"card_depositContainer__2Y_KV"};